import { render } from "./index.vue?vue&type=template&id=52cbb326"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/BaseImageTag/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52cbb326"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52cbb326', __exports__)) {
    api.reload('52cbb326', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=52cbb326", () => {
    api.rerender('52cbb326', render)
  })

}


export default __exports__